var _g, _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 166,
    viewBox: "0 0 152 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5236_17979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.125 85L120.847 110.5H91.4026L106.125 85Z",
    fill: "#F50707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.125 77L85.3908 90.1287H99.1951L88.0272 98.2426L92.2929 111.371L81.125 103.257L69.9571 111.371L74.2228 98.2426L63.0549 90.1287H76.8592L81.125 77Z",
    fill: "#E6A500"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.125,
    y: 83,
    width: 28,
    height: 28,
    rx: 3,
    fill: "#10ABB5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.125,
    cy: 102.5,
    rx: 13,
    ry: 13.5,
    fill: "#A247FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.125,
    y: 60,
    width: 35,
    height: 78,
    fill: "#81B1AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 60.375V125.062C129.5 128.494 128.137 131.784 125.711 134.211C123.284 136.637 119.994 138 116.562 138H77.75V60.375H129.5ZM21.6875 138C18.2563 138 14.9656 136.637 12.5393 134.211C10.1131 131.784 8.75 128.494 8.75 125.062V60.375H60.5V138H21.6875Z",
    fill: "#4E7E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 30.5625C26 24.8438 28.2718 19.3593 32.3155 15.3155C36.3593 11.2718 41.8438 9 47.5625 9C53.2812 9 58.7657 11.2718 62.8095 15.3155C66.8532 19.3593 69.125 24.8438 69.125 30.5625C69.125 24.8438 71.3968 19.3593 75.4405 15.3155C79.4843 11.2718 84.9688 9 90.6875 9C96.4062 9 101.891 11.2718 105.934 15.3155C109.978 19.3593 112.25 24.8438 112.25 30.5625V30.6143C112.25 31.218 112.25 32.943 111.922 34.875H129.5C131.787 34.875 133.981 35.7837 135.599 37.4012C137.216 39.0187 138.125 41.2125 138.125 43.5V52.125C138.125 54.4125 137.216 56.6063 135.599 58.2238C133.981 59.8413 131.787 60.75 129.5 60.75H8.75C6.46251 60.75 4.26871 59.8413 2.6512 58.2238C1.0337 56.6063 0.125 54.4125 0.125 52.125V43.5C0.125 41.2125 1.0337 39.0187 2.6512 37.4012C4.26871 35.7837 6.46251 34.875 8.75 34.875H26.3278C26.0999 33.4664 25.9903 32.0412 26 30.6143V30.5625ZM35.2115 34.875H60.5V30.5625C60.5 28.8635 60.1654 27.1812 59.5152 25.6115C58.865 24.0419 57.9121 22.6157 56.7107 21.4143C55.5093 20.2129 54.0831 19.26 52.5135 18.6098C50.9438 17.9596 49.2615 17.625 47.5625 17.625C45.8635 17.625 44.1812 17.9596 42.6115 18.6098C41.0419 19.26 39.6157 20.2129 38.4143 21.4143C37.2129 22.6157 36.26 24.0419 35.6098 25.6115C34.9596 27.1812 34.625 28.8635 34.625 30.5625C34.625 31.2956 34.6423 32.9258 35.0131 34.2712C35.0649 34.4769 35.1312 34.6787 35.2115 34.875ZM77.75 34.875H103.038C103.118 34.6783 103.184 34.4766 103.237 34.2712C103.608 32.9258 103.625 31.2956 103.625 30.5625C103.625 27.1313 102.262 23.8406 99.8357 21.4143C97.4094 18.9881 94.1187 17.625 90.6875 17.625C87.2563 17.625 83.9656 18.9881 81.5393 21.4143C79.1131 23.8406 77.75 27.1313 77.75 30.5625V34.875Z",
    fill: "#34544F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.875,
    y: 96,
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.875 103.5C101.689 103.5 89.375 115.814 89.375 131C89.375 146.186 101.689 158.5 116.875 158.5C132.061 158.5 144.375 146.186 144.375 131C144.375 115.814 132.061 103.5 116.875 103.5ZM127.709 139.453L125.954 141.847C125.916 141.899 125.867 141.943 125.812 141.976C125.757 142.01 125.696 142.032 125.632 142.042C125.568 142.051 125.503 142.048 125.44 142.033C125.377 142.017 125.318 141.989 125.266 141.951L115.113 134.548C115.05 134.503 114.999 134.443 114.963 134.373C114.928 134.304 114.91 134.227 114.911 134.149V117.25C114.911 116.98 115.132 116.759 115.402 116.759H118.354C118.624 116.759 118.845 116.98 118.845 117.25V132.443L127.599 138.771C127.82 138.925 127.869 139.232 127.709 139.453Z",
    fill: "#34544F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5236_17979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 138,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift2);
export default __webpack_public_path__ + "static/media/gift2.c04855aa889286a758e72e446b10d13c.svg";
export { ForwardRef as ReactComponent };